import { useSelector } from 'react-redux'
import { validationDictSelector } from '~/selectors'

const useValidationDict = () => {
  return useSelector(validationDictSelector)
}

export default useValidationDict
